var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as $ from "jquery";
import * as _ from "lodash";
import "./models/index.js";
import { g as getNewGuid } from "./CommonStringUtils-8860a016.js";
import EnvironmentService, { MSFT_WORKSPACE_ID_LOCAL, MSFT_WORKSPACE_ID_A11YVCURRENT } from "./services/EnvironmentService.js";
import logger, { customErrorObject, ErrorType } from "./services/logging/Logger.js";
import { MigrationErrorMessages } from "./constants/WorkspaceMigration.constants.js";
import { WorkspaceMigrationStatusCodes } from "./models/IAsyncWrapper/WorkspaceMigrationModels.js";
import { isMigrationErrorStatusCode } from "./utils/WorkspaceMigration.utils.js";
import { MSALAuthenticator } from "./services/MSALAuthenticator.js";
import { getApiErrorType, parseVNextApiError } from "./utils/ErrorUtils.js";
import { ApiErrorType, ReadyStateErrorType, ReadyStateErrorDescription } from "./models/ErrorModels.js";
import { AsyncRequestStatus } from "./models/IAsyncWrapper/IAsyncWrapper.js";
const mockRestResult = {
  statusText: "Ok",
  statusCode: 200,
  error: "",
  ensureSuccess: () => {
  },
  getSuccessData: () => null,
  getRawData: () => {
  },
  isSuccessful: () => true
};
function getMockRestResult(statusCode, data = null, settings, correlationId) {
  switch (statusCode) {
    case WorkspaceMigrationStatusCodes.MovedPermanently:
      return new RestResult(
        data,
        "Status text",
        WorkspaceMigrationStatusCodes.MovedPermanently,
        settings,
        "Error",
        settings.headers && settings.headers["X-Correlation-Id"],
        /**
         * TODO - Workspace migration
         * 301 will not include error context in the payload
         */
        {
          displayError: "Workspace migration testing - entity has been perminently moved.",
          type: ApiErrorType.UnknownError,
          correlationId,
          statusCode: WorkspaceMigrationStatusCodes.MovedPermanently
        }
      );
    case WorkspaceMigrationStatusCodes.MethodNotAllowed:
      return new RestResult(
        data,
        "Status text",
        WorkspaceMigrationStatusCodes.MethodNotAllowed,
        settings,
        "Error",
        settings.headers && settings.headers["X-Correlation-Id"],
        {
          displayError: MigrationErrorMessages.MethodNotAllowed(),
          type: ApiErrorType.UserError,
          correlationId,
          statusCode: WorkspaceMigrationStatusCodes.MethodNotAllowed
        }
      );
    case WorkspaceMigrationStatusCodes.NotAcceptable:
      return new RestResult(
        data,
        "Status text",
        WorkspaceMigrationStatusCodes.NotAcceptable,
        settings,
        "Error",
        settings.headers && settings.headers["X-Correlation-Id"],
        {
          displayError: MigrationErrorMessages.NotAcceptable(),
          type: ApiErrorType.UserError,
          correlationId,
          statusCode: WorkspaceMigrationStatusCodes.NotAcceptable
        }
      );
    default:
      return new RestResult(
        data,
        "Status text",
        200,
        settings,
        "",
        settings.headers && settings.headers["X-Correlation-Id"],
        {
          displayError: "",
          type: "",
          correlationId,
          statusCode: 200
        }
      );
  }
}
function isDataReady(request) {
  return request && !request.isLoading && request.data;
}
class RestResult {
  constructor(_data, statusText, statusCode, _requestSettings, error, correlationId, errorContext, completeResponse) {
    __publicField(this, "_dataObj", null);
    __publicField(this, "getError", (result) => {
      var _a;
      if (!this.isSuccessful()) {
        let response = result._data;
        try {
          response = JSON.parse(response);
        } catch (e) {
        }
        return ((_a = response == null ? void 0 : response.InnerException) == null ? void 0 : _a.ExceptionMessage) || (response == null ? void 0 : response.ExceptionMessage) || result.error || ` Status: ${result.statusText}`;
      }
    });
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      const { _requestSettings, errorContext } = RestResult2;
      const { url = "undefined" } = _requestSettings || {};
      return !!(errorContext == null ? void 0 : errorContext.displayError) ? `${errorContext == null ? void 0 : errorContext.displayError}` : `The result wasn't successful (${RestResult2.statusCode})-${RestResult2.statusText} for ${url}. Failed`;
    });
    this._data = _data;
    this.statusText = statusText;
    this.statusCode = statusCode;
    this._requestSettings = _requestSettings;
    this.error = error;
    this.correlationId = correlationId;
    this.errorContext = errorContext;
    this.completeResponse = completeResponse;
  }
  static fromResult(data, isSuccessful = true) {
    if (isSuccessful) {
      return {
        statusText: "Ok",
        statusCode: 200,
        ensureSuccess: () => void 0,
        getSuccessData: () => data,
        getRawData: () => data,
        isSuccessful: () => true
      };
    } else {
      const error = customErrorObject(new Error("Failed on " + data), "RestResultIsNotSuccessful");
      return {
        statusText: "500",
        statusCode: 500,
        error: error.message,
        ensureSuccess: () => {
          throw error;
        },
        getSuccessData: () => {
          throw error;
        },
        getRawData: () => data,
        isSuccessful: () => false,
        errorContext: {
          displayError: error.message,
          type: ApiErrorType.SystemRetryableError,
          correlationId: "CorrelationId not assigned for self generated response",
          statusCode: 500
        }
      };
    }
  }
  ensureSuccess(errorMessage = this._errorMessage) {
    var _a, _b, _c, _d;
    if (!this.isSuccessful()) {
      let response = this._data;
      try {
        response = JSON.parse(response);
      } catch (e) {
      }
      const errorMsg = errorMessage(this, response);
      const error = customErrorObject(new Error(errorMsg), "RestServiceBaseEnsureSuccessFailed");
      const { url = "", method } = this._requestSettings;
      const innerError = {
        message: errorMsg,
        url,
        method,
        statusCode: this.statusCode,
        clientRequestId: (_b = (_a = this.errorContext) == null ? void 0 : _a.correlationId) != null ? _b : "Client CorrelationId not present",
        statusText: (_c = this.statusText) != null ? _c : "Status Text not present"
      };
      error.innerError = innerError;
      const correlationId = (_d = this.errorContext) == null ? void 0 : _d.correlationId;
      error.correlationId = correlationId;
      error.statusText = this.statusText;
      const isAborted = this.isAborted();
      error.isAborted = isAborted;
      logger.error(error, ErrorType.RestServiceBaseEnsureSuccessFailed, {
        innerError,
        correlationId,
        isAborted,
        suppressPopup: true
      });
      if (isMigrationErrorStatusCode({
        data: response,
        status: AsyncRequestStatus.Failed,
        errorContext: {
          statusCode: this.statusCode
        }
      })) {
        logger.warn(errorMsg, {
          isWorkspaceMigration: true,
          correlationId
        });
        return;
      }
      throw error;
    }
  }
  /**
   * This below method would test if the user navigates away from the page, causing the request to get cancelled.
   */
  isAborted() {
    return this.statusText == "abort";
  }
  getSuccessData(errorMessage) {
    this.ensureSuccess(errorMessage);
    if (!this._dataObj) {
      try {
        this._dataObj = this._data && JSON.parse(this._data);
      } catch (e) {
        console.warn("getSuccessData JSON parsing error: ", e);
        this._dataObj = this._data;
      }
    }
    return this._dataObj;
  }
  getRawData() {
    return this._data;
  }
  isSuccessful() {
    return this.statusCode < 400 && this.statusCode >= 200;
  }
}
const _globalMiddleWare = [];
function addGlobalMiddleWare(middleWare) {
  _globalMiddleWare.push(middleWare);
}
class RestServiceBase {
  constructor(endpoint, resourceUrlPath, customError) {
    __publicField(this, "_baseUrl");
    __publicField(this, "_middleWare");
    __publicField(this, "_customError");
    function noTrailingSlash(path) {
      return path.replace(/\/$/, "");
    }
    function withLeadingSlash(path) {
      if (!path) {
        return "";
      } else if (!path.startsWith("/")) {
        return `/${path}`;
      }
      return path;
    }
    this._baseUrl = noTrailingSlash(endpoint.url) + withLeadingSlash(resourceUrlPath);
    this._middleWare = [];
    this._customError = customError;
    if (endpoint.tokenScope) {
      this.addMiddleWare(MSALAuthenticator.instance.getMiddleware({ tokenScope: endpoint.tokenScope }));
    }
  }
  get middleWare() {
    return [..._globalMiddleWare, ...this._middleWare];
  }
  get BaseUrl() {
    return this._baseUrl;
  }
  encodeOdataParam(param) {
    return param.replace("'", "''");
  }
  addMiddleWare(middleWare) {
    this._middleWare.push(middleWare);
  }
  _get(path, timeout, headers) {
    return this.execute("GET", path, null, timeout, headers);
  }
  _post(data, path, timeout) {
    return this.execute("post", path, data, timeout);
  }
  _put(data, path, headers, timeout) {
    return this.execute("put", path, data, timeout, headers);
  }
  _patch(data, path) {
    return this.execute("patch", path, data);
  }
  _delete(path, data) {
    return this.execute("delete", path, data);
  }
  _postFormData(path, data) {
    return this.postFormData(path, data);
  }
  isAbsolutePath(path) {
    return /^(http|\/\/)/.test(path);
  }
  /**
   * Executes the ajax call
   * @param settings the settings to use when executing
   */
  executeAjaxCall(settings) {
    if (EnvironmentService.wsplitReturn301() && settings.method === "GET" && /**
    * Ignore calls required for init
    */
    !settings.url.includes(`management.azure.com`) && !settings.url.includes(`/api/users`) && !settings.url.includes(
      `https://default.exp-tas.com/exptas74/eecba607-edb2-4774-bced-ac5e1808e489-exponexptempux/api/v1/tas`
    ) && !settings.url.includes("/experimentationGroups/root") && !settings.url.includes("/workspaceMigrationStatus") && !settings.url.includes("/actionauthorized")) {
      const correlationId = getNewGuid();
      _.extend(settings, { headers: __spreadProps(__spreadValues({}, settings.headers), { "X-Correlation-Id": correlationId }) });
      return new Promise((resolve) => {
        let redirectWsid = EnvironmentService.wsplitRedirectWorkspaceId();
        const fallBackWsid = EnvironmentService.usePreProd() ? MSFT_WORKSPACE_ID_LOCAL : MSFT_WORKSPACE_ID_A11YVCURRENT;
        redirectWsid = !!redirectWsid ? redirectWsid : fallBackWsid;
        setTimeout(() => {
          resolve(
            getMockRestResult(
              WorkspaceMigrationStatusCodes.MovedPermanently,
              /**
               * Must be string?
               * Returned value called by JSON.parse
               */
              JSON.stringify({ workspaceId: redirectWsid }),
              settings,
              correlationId
            )
          );
        }, 1e3);
      });
    }
    const updates = !!["PUT", "POST", "PATCH", "DELETE"].filter((element) => {
      var _a;
      return element.toLowerCase() === ((_a = settings == null ? void 0 : settings.method) == null ? void 0 : _a.toLowerCase());
    }).length;
    if (EnvironmentService.wsplitReadOnly() && updates && !settings.url.includes("/setIsAne.aspx")) {
      const correlationId = getNewGuid();
      _.extend(settings, { headers: __spreadProps(__spreadValues({}, settings.headers), { "X-Correlation-Id": correlationId }) });
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(getMockRestResult(WorkspaceMigrationStatusCodes.MethodNotAllowed, null, settings, correlationId));
        }, 1e3);
      });
    }
    if (EnvironmentService.wsplitCannotUpdate() && updates && !settings.url.includes("/setIsAne.aspx")) {
      const correlationId = getNewGuid();
      _.extend(settings, { headers: __spreadProps(__spreadValues({}, settings.headers), { "X-Correlation-Id": correlationId }) });
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(getMockRestResult(WorkspaceMigrationStatusCodes.NotAcceptable, null, settings, correlationId));
        }, 1e3);
      });
    }
    const promise = new Promise((resolve, reject) => {
      const correlationId = getNewGuid();
      _.extend(settings, { headers: __spreadProps(__spreadValues({}, settings.headers), { "X-Correlation-Id": correlationId }) });
      const actualSettings = _.merge(settings, {
        error: (r, s, e) => {
          var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
          let errorContext;
          if (r.status !== 200) {
            const _a = settings, { headers } = _a, rest = __objRest(_a, ["headers"]);
            const { state = () => null, status, statusText, readyState } = r || {};
            logger.log("executeAjaxCall_error", __spreadProps(__spreadValues({}, rest), {
              state: state(),
              status: (_b = status == null ? void 0 : status.toString()) != null ? _b : "undefined",
              statusText,
              readyState: getReadyState(readyState),
              readyStateText: getReadyStateText(readyState),
              errorTextStatus: s,
              type: getApiErrorType(status),
              error: e != null ? e : "No error information is present",
              correlationId
            }));
          }
          if (EnvironmentService.enableIApiErrorExceptionHandlingToCT()) {
            const apiError = parseVNextApiError((_c = r == null ? void 0 : r.responseJSON) == null ? void 0 : _c.error);
            errorContext = apiError !== void 0 ? __spreadValues({
              displayError: (_d = apiError == null ? void 0 : apiError.message) != null ? _d : "No error information is present",
              type: getApiErrorType((_e = r == null ? void 0 : r.status) != null ? _e : 0),
              correlationId,
              errorCorrelationId: correlationId,
              statusCode: (_f = r == null ? void 0 : r.status) != null ? _f : 0,
              rawError: r == null ? void 0 : r.responseJSON,
              typeOfRawError: apiError.code,
              apiError
            }, !!this._customError ? (_g = this._customError(r)) != null ? _g : {} : {}) : __spreadValues({
              displayError: (_o = (_n = (_m = (_k = (_i = (_h = r == null ? void 0 : r.responseJSON) == null ? void 0 : _h.InnerException) == null ? void 0 : _i.ExceptionMessage) != null ? _k : (_j = r == null ? void 0 : r.responseJSON) == null ? void 0 : _j.ExceptionMessage) != null ? _m : (_l = r == null ? void 0 : r.responseJSON) == null ? void 0 : _l.Message) != null ? _n : r == null ? void 0 : r.responseText) != null ? _o : "No error information is present",
              type: getApiErrorType((_p = r == null ? void 0 : r.status) != null ? _p : 0),
              correlationId,
              statusCode: (_q = r == null ? void 0 : r.status) != null ? _q : 0
            }, !!this._customError ? (_r = this._customError(r)) != null ? _r : {} : {});
          } else {
            errorContext = __spreadValues({
              displayError: (_z = (_y = (_x = (_v = (_t = (_s = r == null ? void 0 : r.responseJSON) == null ? void 0 : _s.InnerException) == null ? void 0 : _t.ExceptionMessage) != null ? _v : (_u = r == null ? void 0 : r.responseJSON) == null ? void 0 : _u.ExceptionMessage) != null ? _x : (_w = r == null ? void 0 : r.responseJSON) == null ? void 0 : _w.Message) != null ? _y : r == null ? void 0 : r.responseText) != null ? _z : "No error information is present",
              type: getApiErrorType((_A = r == null ? void 0 : r.status) != null ? _A : 0),
              correlationId,
              statusCode: (_B = r == null ? void 0 : r.status) != null ? _B : 0
            }, !!this._customError ? (_C = this._customError(r)) != null ? _C : {} : {});
          }
          if (errorContext.statusCode === WorkspaceMigrationStatusCodes.MethodNotAllowed) {
            const displayError = EnvironmentService.wsplitMethodNotAllowedText();
            errorContext = __spreadProps(__spreadValues({}, errorContext), {
              displayError: (errorContext == null ? void 0 : errorContext.displayError) || displayError
            });
          }
          if (errorContext.statusCode === WorkspaceMigrationStatusCodes.NotAcceptable) {
            const displayError = EnvironmentService.wsplitNotAcceptableText();
            errorContext = __spreadProps(__spreadValues({}, errorContext), {
              displayError: (errorContext == null ? void 0 : errorContext.displayError) || displayError
            });
          }
          resolve(
            new RestResult(
              r.responseText,
              s,
              r.status,
              settings,
              e,
              settings.headers && settings.headers["X-Correlation-Id"],
              errorContext,
              r
            )
          );
        },
        success: (d, s, r) => {
          if (EnvironmentService.includeCompleteResponseInRestResult()) {
            resolve(new RestResult(r.responseText, s, r.status, settings, void 0, void 0, void 0, r));
          } else {
            resolve(new RestResult(r.responseText, s, r.status, settings));
          }
        }
      });
      $.ajax(actualSettings);
    });
    return promise;
  }
  /**
   * Get's the middleware delegate for the given index
   * @param index the index of the middleware to get.  Defaulted to the head of the middleware
   */
  getNextMiddlewareDelegate(middleware, index = 0) {
    let currentDelegate;
    if (middleware.length > index) {
      currentDelegate = (s) => middleware[index](s, this.getNextMiddlewareDelegate(middleware, index + 1));
    } else {
      currentDelegate = (s) => this.executeAjaxCall(s);
    }
    currentDelegate.context = {
      index,
      middleWarePipeline: middleware
    };
    return currentDelegate;
  }
  //execute the service call
  execute(verb, path = "", data, timeout, headers) {
    const url = this.isAbsolutePath(path) ? path : `${this.BaseUrl}${path || ""}`;
    const settings = {
      contentType: "application/json",
      data: data && JSON.stringify(data),
      dataType: "json",
      timeout,
      method: verb,
      url: `${url || ""}`,
      headers
    };
    return this.getNextMiddlewareDelegate(this.middleWare)(settings);
  }
  // http://stackoverflow.com/questions/5392344/sending-multipart-formdata-with-jquery-ajax/5976031#5976031
  // It’s imperative that you set the contentType option to false, forcing jQuery not to add a Content-Type header for you,
  // otherwise, the boundary string will be missing from it.
  // Also, you must leave the processData flag set to false, otherwise, jQuery will try to convert your FormData into a string,
  // which will fail.
  postFormData(path = "", data) {
    const url = this.isAbsolutePath(path) ? path : `${this.BaseUrl}${path || ""}`;
    const settings = {
      contentType: false,
      data,
      cache: false,
      processData: false,
      method: "POST",
      timeout: 0,
      url: `${url || ""}`
    };
    return this.getNextMiddlewareDelegate(this.middleWare)(settings);
  }
}
const getAsyncWrapperFromRestResult = (restResult) => {
  var _a;
  return {
    data: restResult.isSuccessful() ? restResult.getSuccessData() : null,
    status: restResult.isSuccessful() ? AsyncRequestStatus.Completed : AsyncRequestStatus.Failed,
    error: (_a = restResult == null ? void 0 : restResult.errorContext) == null ? void 0 : _a.displayError,
    errorContext: restResult.errorContext
  };
};
const getReadyState = (state) => {
  switch (state) {
    case 0:
      return ReadyStateErrorType.UNSENT;
    case 1:
      return ReadyStateErrorType.OPENED;
    case 2:
      return ReadyStateErrorType.HEADERS_RECEIVED;
    case 3:
      return ReadyStateErrorType.LOADING;
    case 4:
      return ReadyStateErrorType.DONE;
    default:
      return "unknown";
  }
};
const getReadyStateText = (state) => {
  switch (state) {
    case 0:
      return ReadyStateErrorDescription.UNSENT;
    case 1:
      return ReadyStateErrorDescription.OPENED;
    case 2:
      return ReadyStateErrorDescription.HEADERS_RECEIVED;
    case 3:
      return ReadyStateErrorDescription.LOADING;
    case 4:
      return ReadyStateErrorDescription.DONE;
    default:
      return "unknown";
  }
};
export {
  RestResult as R,
  RestServiceBase as a,
  addGlobalMiddleWare as b,
  getAsyncWrapperFromRestResult as c,
  getReadyState as d,
  getReadyStateText as e,
  getMockRestResult as g,
  isDataReady as i,
  mockRestResult as m
};
//# sourceMappingURL=RestServiceBase-1fb330a3.js.map
